import BigNumber from 'decimal.js';
import * as yup from 'yup';

import { toBN } from '@utils/formaters.utils';

import { ErrorMessages } from '@constants/common/messages.constants';
import { INFO_REGEX } from '@constants/common/regex.constants';
import {
  MAX_SLIDER_VALUE,
  MIN_SLIDER_VALUE,
} from '@constants/vaults/vault.constants';

export const amountYup = (balance: BigNumber) =>
  yup
    .string()
    .typeError(ErrorMessages.InvalidType)
    .required(ErrorMessages.Required)
    .test(
      'non-zero',
      ErrorMessages.NonZeroAmount,
      (value) => !toBN(value).equals(0),
    )
    .test(
      'max',
      ErrorMessages.Max.replace('[max]', balance.toString()),
      (value) => toBN(value).lte(balance),
    );

export const sliderYup = yup
  .number()
  .min(MIN_SLIDER_VALUE)
  .max(MAX_SLIDER_VALUE)
  .required(ErrorMessages.Required);

export const infoRequiredYup = (maxValue: number, minValue: number) =>
  yup
    .string()
    .trim()
    .required(ErrorMessages.Required)
    .min(minValue, ({ min }) =>
      ErrorMessages.MinSymbols.replace('[min]', String(min)),
    )
    .max(maxValue, ({ max }) =>
      ErrorMessages.MaxSymbols.replace('[max]', String(max)),
    )
    .matches(INFO_REGEX, ErrorMessages.UnexpectedSymbol);
